import AddonFoodsPrompt from './addon-foods-prompt.vue';
import AssociatedFoodsPrompt from './associated-foods-prompt.vue';
import EditMealPrompt from './edit-meal-prompt.vue';
import ExternalSourcePrompt from './external-source-prompt.vue';
import FinalPrompt from './final-prompt.vue';
import FoodSearchPrompt from './food-search-prompt.vue';
import GeneralAssociatedFoodsPrompt from './general-associated-foods-prompt.vue';
import MealAddPrompt from './meal-add-prompt.vue';
import MealDurationPrompt from './meal-duration-prompt.vue';
import MealGapPrompt from './meal-gap-prompt.vue';
import MealTimePrompt from './meal-time-prompt.vue';
import ReadyMealPrompt from './ready-meal-prompt.vue';
import RecallDatePrompt from './recall-date-prompt.vue';
import RedirectPrompt from './redirect-prompt.vue';
import ReviewConfirmPrompt from './review-confirm-prompt.vue';
import SameAsBeforePrompt from './same-as-before-prompt.vue';
import SleepSchedulePrompt from './sleep-schedule-prompt.vue';
import SplitFoodPrompt from './split-food-prompt.vue';
import SubmitPrompt from './submit-prompt.vue';

export default {
  AddonFoodsPrompt,
  AssociatedFoodsPrompt,
  GeneralAssociatedFoodsPrompt,
  EditMealPrompt,
  ExternalSourcePrompt,
  FinalPrompt,
  FoodSearchPrompt,
  MealAddPrompt,
  MealDurationPrompt,
  MealGapPrompt,
  MealTimePrompt,
  ReadyMealPrompt,
  RecallDatePrompt,
  RedirectPrompt,
  ReviewConfirmPrompt,
  SameAsBeforePrompt,
  SleepSchedulePrompt,
  SplitFoodPrompt,
  SubmitPrompt,
};
